import {SynapiItem} from "./SynapiItem";

export class SynapiListItems {
    milliseconds: number;
    total: number;
    page: number;
    pagecount: number;
    size: number;
    items: SynapiItem[] = [];

    constructor(items?: SynapiItem[]){
      this.size=0;
      this.page=1;
      if(!items){
        this.total=0;
        this.items = [];
      } else {
        this.total=items.length;
        this.items = items;
      }

    }
}
